export default __webpack_public_path__ + "static/media/download.c729d294.svg";